import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QualityControlRoutingModule } from './quality-control.routes';
import { MaterialModule } from '../../material.module';
import { QualityControlOverviewComponent } from './pages/quality-control-overview/quality-control-overview.component';
import { SharedModule } from '../../shared/shared.module';
import { ReactiveFormsModule } from '@angular/forms';
import { QualityControlService } from './services/quality-control/quality-control.service';
import { CqStepsComponent } from './qc-steps/qc-steps.component';
import { ChecklistQualityControlComponent } from './components/checklist-quality-control/checklist-quality-control.component';
import { ApprovalRejectionComponent } from './components/approval-rejection/approval-rejection.component';

@NgModule({
  declarations: [
    QualityControlOverviewComponent,
    CqStepsComponent,
    ChecklistQualityControlComponent,
    ApprovalRejectionComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    MaterialModule,
    ReactiveFormsModule,
    QualityControlRoutingModule,
  ],
  providers: [QualityControlService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class QualityControlModule {}
